import { createAsyncThunk } from '@reduxjs/toolkit';
import { AICoachGoalsApi, GoalProgress } from 'api/AICoachGoalsApi';

import { ErrorResponse } from './ErrorResponse';

export const createGetGoalProgressThunk = (api: AICoachGoalsApi) =>
  createAsyncThunk('reports/getGoalProgress', async (borrowerId: string, thunkApi) => {
    try {
      const goalProgress: GoalProgress | null = await api.updateGoalProgress(borrowerId);
      return goalProgress;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue((error as ErrorResponse).response.data);
    }
  });
